import { Message } from "element-ui";
import getLodop from "@/assets/js/LodopFuncs.js";
/**
 * commonLodopPrint
 * @param {*} elementId  // elementId: 要打印的HTML元素的ID
 * @param {*} PRINTER_INDEX  // PRINTER_INDEX: 打印机索引 (-1 表示默认打印机)
 */
function commonLodopPrint(elementId, PRINTER_INDEX) {
  const ele = document.getElementById(elementId);
  const html = ele.innerHTML;
  // Convert element dimensions from pixels to millimeters (1px ≈ 0.264mm)
  let h = ele.offsetHeight;
  h = `${h / 3.78}mm`;
  let w = ele.offsetWidth;
  w = `${w / 3.78}mm`;
  const LODOP = getLodop();

  if (LODOP) {
    LODOP.PRINT_INIT("");
    // Add license information for Lodop printer control
    LODOP.SET_LICENSES(
      "广州富米科技有限公司",
      "A564177D3271E3CFF371162E393C53F6AE2",
      "廣州富米科技有限公司",
      "750CF994CE8CD4FE765C2B772159BF47828"
    );
    LODOP.SET_LICENSES(
      "THIRD LICENSE",
      "",
      "Guangzhou Fumi Technology Co., Ltd.",
      "CA02B8F057FF195E4C65561D1AD6492A379"
    );

    // Set printer (-1 indicates default printer)
    const re = LODOP.SET_PRINTER_INDEX(PRINTER_INDEX);

    if (re) {
      // Add HTML content to print with 3mm margins
      LODOP.ADD_PRINT_HTM("3mm", "3mm", w, h, html);
      LODOP.PRINT(); // Execute direct printing
      // LODOP.PREVIEW(); // Uncomment this for preview mode
    } else {
      Message.error("打印机设置失败;请检查是否设置默认打印机");
    }
  }
}

export default commonLodopPrint;



// WEBPACK FOOTER //
// ./src/utils/lodopPrint.js